<template>
	<div>
		<div class="jinbu flex  align-items align-content">
			<div class="pointer" @click="shouye">首页</div>
			<div>/学习视频</div>
		</div>
	
	<div class="w1200" style="padding: 20px;">
		<div class="flex benben-flex-layout flex-wrap align-center">
			<div class="video_0">视频标题：</div>
			<el-input class="video_1" v-model="input" placeholder="请输入"></el-input>
			<div class="video_0 margin_left">视频分类：</div>
			<el-select class="video_1" v-model="value1" placeholder="请选择" filterable clearable>
			    <el-option
			      v-for="item in options1"
			      :key="item.aid"
			      :label="item.name"
			      :value="item.aid">
			    </el-option>
			  </el-select>
			<div class="video_0 margin_left">创建时间：</div>
			<el-date-picker
			    class="video_1"
				value-format="yyyy-MM-dd"
			    v-model="value2"
			    type="date"
			    placeholder="选择日期">
			</el-date-picker>
			<div class="flex justify-content align-content align-center margin_left video_2 pointer" @click="caozuo(1)">
				<img class="video_2_1" src="../../static/image/16.png" alt="" srcset="">
				<div>查询</div>
			</div>
			<div class="flex justify-content align-content align-center margin_left video_3 pointer" @click="caozuo(2)">
				<img class="video_2_1" src="../../static/image/17.png" alt="" srcset="">
				<div>重置</div>
			</div>
		</div>
		<div class="video_4">
			<div class="">
				<el-table :data="tableData" style="width: 100%" border :header-cell-style="headerCell" :cell-style="{ textAlign: 'center' }">
				    <el-table-column prop="aid" label="序号" width="80"></el-table-column>
				    <el-table-column prop="title" label="视频标题"></el-table-column>
				    <el-table-column prop="introduce" label="视频简介"></el-table-column>
				    <el-table-column prop="videotype_name" label="视频分类"></el-table-column>
				    <el-table-column prop="date" label="视频详情">
						<template slot-scope="scope">
							<!-- scope.row -->
							<div class="relative" @click="caozuo(3,scope.row.url)">
								<img class="video_4_1" :src="scope.row.url +'?x-oss-process=video/snapshot,t_0,f_jpg'" alt="" srcset="">
								<img class="video_4_2 absolute" src="../../static/image/18.png" alt="" srcset="">
							</div>
						</template>
					</el-table-column>
				    <el-table-column prop="create_time" label="创建时间"></el-table-column>
				</el-table>
			</div>
			<div class="video_4_3">
				<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange" v-if="total > 0"
					:current-page.sync="page" :page-size="page_size" layout="total, sizes,prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="" :visible.sync="dialogVisible" width="1200px" >
			<video width="100%" height="675" controls>
			    <source :src="video_url" type="video/mp4">
			</video>
		  <!-- <span>这是一段信息</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span> -->
		</el-dialog>
	</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				video_url:'https://xiaobailing.oss-cn-shenzhen.aliyuncs.com/m9655/2025-06-06/c9ff518d67fb339aa130611ecad99c061749208084219.mp4',
				dialogVisible:false,
				page:1,
				page_size:10,
				total:100,
				headerCell: {
					'background-color': '#F2F3F5',
					'text-align': 'center',
				},
				input:'',
				options1:[],
				value1: '',
				value2:'',
				tableData:[],
			}
		},
		created() {
			this.ordeList()
			this.post6915578674d9d()
		},
		methods:{
			// 操作
			caozuo(type,item){
				if(type == 1){ // 搜索
					this.page = 1
					this.ordeList()
				}else if(type == 2){ // 重置
					this.value1 = ''
					this.value2 = ''
					this.input = ''
					this.ordeList()
				}else if(type == 3){ // 视频播放
				    this.video_url = item
					this.dialogVisible = true
				}
				
			},
			shouye(){
				this.$router.push({
					name: 'index',
				});
			},
			handleSizeChange1(val) {
				// console.log(`每页 ${val} 条`,this.page);
				this.page_size = val
				// this.ordeList()
			},
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.page = val
				// this.ordeList()
			},
			// 列表
			ordeList() {
				let page = {
					size: this.page_size,
					page: this.page,
					videotype_id:this.value1,
					title:this.input,
					create_time:this.value2
					// status: 1,
					// keyword: this.input
				}
				this.$api.post(this.$apiUrls.post691552dae8cdb, page).then((res) => {
					if (res.code == 1) {
						this.tableData = res.data.data
						this.total = res.data.total
					// console.log(this.total,res.data.total,123)
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 分类
			post6915578674d9d() {
				this.$api.post(this.$apiUrls.post6915578674d9d, {
					
				}).then((res) => {
					if (res.code == 1) {
						this.options1 = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
		},
	}
</script>

<style  lang="scss" scoped>
	::v-deep {
		.video_1{
			width: 200px;
			height: 32px;
		}
		.video_1 .el-input__inner {
			height: 32px;
		}
		.video_1 .el-icon-circle-close,
		.video_1 .el-icon-arrow-up{
			line-height: 32px !important;
		}
		.video_1 .el-icon-date{
			line-height: 32px !important;
		}
		.video_4_3{
			
			.number{
				width: 32px;
				height: 32px;
				border: 1px solid rgba(0,0,0,0.15);
				margin: 0 8px 0 0;
			}
			.active{
				border: 1px solid #004EA1;
				background: #004EA1;
				color: #FFFFFF;
			}
			.el-icon-arrow-right,
			.el-icon-arrow-left{
				width: 32px;
				height: 32px;
				border: 1px solid rgba(0,0,0,0.15);
				line-height: 32px;
			}
		}
	}
	.margin_left{
		margin-left: 20px;
	}
	.video_0{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.video_2{
		width: 72px;
		height: 32px;
		background: #004EA1;
		border-radius: 4px 4px 4px 4px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.video_2_1{
		width: 14px;
		height: 14px;
		margin-right: 8px;
	}
	.video_3{
		width: 72px;
		height: 32px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #004EA1;
		font-weight: 400;
		font-size: 14px;
		color: #004EA1;
	}
	.video_4{
		margin: 20px 0 0 0;
	}
	.video_4_1{
		width: 160px;
		height: 90px;
	}
	.video_4_2{
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
		width: 24px;
		height: 24px;
	}
	.video_4_3{
		text-align: center;
		margin-top: 20px;
	}
</style>